
import React, { useState } from "react";
import { MapContainer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import mapData from "../../data/maps/sa-local-municipalities-extracted.json";
import "../../styles/map.css";

const LocalMunicipalityMap = ({
  data,
  hoverText,
  dataSource,
  width = "95%",
  annotatedCssContainer = "census-info-hover",
  annotatedCssText = "census-info",
}) => {
  const center = [-29.4856, 26.124];
  const [onselect, setOnselect] = useState({});

  const mapDisplayData = {
    type: "FeatureCollection",
    features: mapData.map((feature) => {
      const props = feature.properties;
      const name = props.MAP_TITLE || props.MUNICNAME;

      const match = data?.find(
        (record) => record.type.toLowerCase() === name.toLowerCase()
      );

      return {
        type: "Feature",
        properties: {
          ...props,
          displayName: name,
          NYSEvents: match ? match.percent : 0,
        },
        geometry: feature.geometry,
      };
    }),
  };

  /** Map color scale */
  const mapPolygonColorToEvents = (n) =>
    n > 40 ? "#c0011d"
      : n > 20 ? "#f43926"
        : n > 10 ? "#ff8645"
          : n > 5 ? "#fbb144"
            : n > 0 ? "#ffd672"
              : "#f8ffb8";

  /** Polygon styling */
  const style = (feature) => ({
    fillColor: mapPolygonColorToEvents(feature.properties.NYSEvents),
    weight: 1,
    opacity: 1,
    color: "black",
    dashArray: "2",
    fillOpacity: 0.75,
  });

  /** Hover behavior */
  const resetHighlight = (e) => {
    setOnselect({});
    e.target.setStyle(style(e.target.feature));
  };

  const highlightFeature = (e) => {
    const layer = e.target;
    const { displayName, NYSEvents } = layer.feature.properties;

    setOnselect({
      name: displayName,
      NYSEvents,
    });

    layer.setStyle({
      weight: 1,
      color: "black",
      fillOpacity: 1,
    });
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      mouseover: highlightFeature,
      mouseout: resetHighlight,
    });
  };

  const mapStyle = {
    height: "600px",
    width,
    margin: "0 auto",
    zIndex: 1,
  };

  return (
    <div className="local-municipalities-container">
      <div className="header"></div>

      {!onselect.name && (
        <div className={annotatedCssContainer}>
          <strong>{hoverText}</strong>
          <p>Hover on each Local Municipality for more details</p>
        </div>
      )}

      {onselect.name && (
        <ul className={annotatedCssText}>
          <li><strong>{onselect.name}</strong></li>
          <br />
          <li>Total {dataSource}: {onselect.NYSEvents}%</li>
        </ul>
      )}

      <MapContainer
        zoom={6}
        scrollWheelZoom={false}
        style={mapStyle}
        center={center}
        preferCanvas
      >
        <GeoJSON
          data={mapDisplayData.features}
          style={style}
          onEachFeature={onEachFeature}
        />
      </MapContainer>
    </div>
  );
};

export default LocalMunicipalityMap;
